import React, {useEffect, useState} from 'react';
import {IPropsView} from '../Config/Button.types';
import ButtonView from '../Views/Button.view';

const Button = ({
    classNameDiv = '',
    onClick = () => {},
    id = '',
    classNameButton,
    children,
    setButtonToBeEnableAfterPress,
    onKeyUp,
    onKeyDown,
    onKeyPress,
    isDisabledActive = true,
    isDisabledProp = false}: IPropsView) => {
    const [disable, setDisable] = useState(isDisabledProp);
    const [classNameDisable, setClassNameDisable] = useState('');
    const disableOnClick = (e) => {
        onClick(e);
        setDisable(true);
    };

    useEffect(() => {
        setDisable(isDisabledProp);
    }, [isDisabledProp]);
    useEffect(() => {
        const isNeedToAddDisabledCss = disable && isDisabledActive;

        isNeedToAddDisabledCss ? setClassNameDisable(classNameButton + ' btn-disabled') : setClassNameDisable(classNameButton);
    }, [disable, classNameButton]);
    useEffect(() => {
        const isSetButtonToBeEnableAfterPressExist = setButtonToBeEnableAfterPress !== undefined;

        isSetButtonToBeEnableAfterPressExist && setDisable(false);
    }, [setButtonToBeEnableAfterPress]);

    return <ButtonView
        classNameDiv={classNameDiv}
        onKeyUp={onKeyUp}
        id={id}
        classNameDisable={classNameDisable}
        onKeyDown={onKeyDown}
        onKeyPress={onKeyPress}
        disabled={isDisabledActive && disable}
        disableOnClick={disableOnClick}>{children}</ButtonView>;
};

export default Button;
